module.exports = __webpack_public_path__ + "static/media/onboarding_amazon.3bb4b2bc.svg";